// @ts-nocheck
import React from 'react';
import { Redirect, Route, Switch } from 'react-router-dom';

import { getDashboardRoutes } from '@/routes/dashboard';
import { useUserType } from '@/hooks/query';
import DashboardPage from './DashboardPage';

/**
 * Dashboard inner route content.
 */
function DashboardContentRouteContent({ route }) {
  return (
    <DashboardPage
      name={route.name}
      Component={route.component}
      pageTitle={route.pageTitle}
      backLink={route.backLink}
      hint={route.hint}
      sidebarExpand={route.sidebarExpand}
      pageType={route.pageType}
      defaultSearchResource={route.defaultSearchResource}
    />
  );
}

/**
 * Dashboard content route.
 */
export default function DashboardContentRoute() {
  const routes = getDashboardRoutes();
  const userType = String(useUserType() || '').toLowerCase();

  return (
    <Route pathname="/">
      <Switch>
        {routes.map((route, index) => (
          <Route exact={route.exact} key={index} path={`${route.path}`}>
            {Array.isArray(route.userTypes) &&
            !route.userTypes
              .map((type) => String(type || '').toLowerCase())
              .includes(userType) ? (
              <Redirect to={{ pathname: '/' }} />
            ) : (
              <DashboardContentRouteContent route={route} />
            )}
          </Route>
        ))}
      </Switch>
    </Route>
  );
}
